import { styled } from '@mui/material';

export const Field = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const FieldLabel = styled('label')({
  fontSize: 14,
  fontWeight: 700,
});

export const TextInput = styled('input')(
  {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 42,
    padding: '8px 12px',
    border: '1px solid',
    borderRadius: 4,
    font: 'inherit',
  },
  ({ theme }) => ({
    borderColor: theme.palette.novotalk.$textColorLightGray,
    color: theme.palette.novotalk.$textColorDarkBlue,
  }),
);

export const LessonList = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 220,
  border: '1px solid #d7dce2',
  borderRadius: 4,
  overflowY: 'auto',
});

export const LessonItem = styled('label')({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  minHeight: 40,
  padding: '4px 12px',
  borderBottom: '1px solid #e8ebef',
  cursor: 'pointer',
  '&:last-child': {
    borderBottom: 0,
  },
});

export const ErrorText = styled('div')({
  color: '#b42318',
  fontSize: 14,
});

export const Results = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export const ResultList = styled('ul')({
  margin: 0,
  paddingLeft: 22,
  lineHeight: 1.7,
});
